import React from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { getUserRole } from "../../utils/tokenUtils";
import SidebarBrand from "../sidebarBrand/SidebarBrand";
import Sidebar from "../sidebar/Sidebar";
import EditTeamMember from "../editTeamMember/EditTeamMember";
import Dashboard from "../dashboard/Dashboard";
import BrandVoice from "../brandVoice/BrandVoice";
import TaskHistory from "../taskHistory/TaskHistory";
import Support from "../support/Support";
import Task from "../Task/Task";

import "../mainContainer/MainContainer.css";

const Main: React.FC = () => {
  const role = getUserRole();
  const location = useLocation();
  const navigate = useNavigate();

  const currentTab = location.pathname.split("/")[2] || "";

  const handleTabChange = (tab: string) => {
    const role = getUserRole(); // or use from context/state
    if (role === "Admin") {
      navigate(`/admin/${tab}`);
    } else {
      navigate(`/user/${tab}`);
    }
  };


  const SidebarComponent = role === "Admin" ? SidebarBrand : Sidebar;

  return (
    <div className="app-container" style={{ display: "flex" }}>
      <SidebarComponent activeTab={currentTab} setActiveTab={handleTabChange} />

      <div className="main-content" style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<EditTeamMember />} />

          <Route
            path="dashboard"
            element={
           
                <Dashboard  />
              
            }
          />

          {role === "admin" ? (
            <Route
              path="brand"
              element={<BrandVoice activeTab="brand" />}
            />
          ) : (
            <Route
              path="tasks"
              element={<Task activeTab="tasks" />}
            />
          )}

          <Route path="taskhistory" element={<TaskHistory activeTab="taskhistory" />} />
          {/* <Route path="support" element={<Support />} /> */}

          {/* Fallback route */}
          <Route path="*" element={<Navigate to="/main" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default Main;
